import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "meeting-price-container meeting-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-title" }, "Send an Invite"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Review")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "price-container" }
const _hoisted_5 = { class: "review-section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sub-header" }, "Price", -1 /* HOISTED */)
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "review-section" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sub-header" }, "Meeting Location", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "description"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Video Link: ")
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "description"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Phone Number: ")
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 2,
  class: "description"
}
const _hoisted_17 = { class: "line" }
const _hoisted_18 = {
  key: 0,
  class: "line"
}
const _hoisted_19 = { class: "line" }
const _hoisted_20 = {
  key: 3,
  class: "description"
}
const _hoisted_21 = {
  key: 4,
  class: "description"
}
const _hoisted_22 = { class: "button-container" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString($props.invite.price.currency) + _toDisplayString($props.invite.price.amount) + " for " + _toDisplayString($props.invite.minutes) + " minutes", 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          ($props.invite?.location?.type == 'video')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("a", {
                  href: $props.invite.location.fields.link,
                  target: "_blank"
                }, _toDisplayString($props.invite.location.fields.link), 9 /* TEXT, PROPS */, _hoisted_12)
              ]))
            : ($props.invite?.location?.type == 'phone')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("a", {
                    href: 'tel:'+$props.invite.location.fields.number,
                    target: "_blank"
                  }, _toDisplayString($props.invite.location.fields.number), 9 /* TEXT, PROPS */, _hoisted_15)
                ]))
              : ($props.invite?.location?.type == 'physical')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString($props.invite.location.fields.street1), 1 /* TEXT */),
                    ($props.invite.location.fields.street2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($props.invite.location.fields.street2), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_19, _toDisplayString($props.invite.location.fields.city) + ", " + _toDisplayString($props.invite.location.fields.state) + " " + _toDisplayString($props.invite.location.fields.postal), 1 /* TEXT */)
                  ]))
                : ($props.invite?.location?.type == 'other')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($props.invite.location.fields.note), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, "No Location information provided"))
        ]),
        ($props.invite.payer)
          ? (_openBlock(), _createBlock($setup["PaymentButton"], {
              key: 0,
              payment: $setup.selectedPaymentId,
              "onUpdate:payment": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedPaymentId) = $event)),
              price: $props.invite.price.amount
            }, null, 8 /* PROPS */, ["payment", "price"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        class: "borderless previous",
        onClick: $setup.previous
      }, "Back"),
      _createElementVNode("button", {
        class: "primary confirm-details",
        disabled: !!$props.invite.payer && !$setup.selectedPaymentId,
        onClick: $setup.setPayment
      }, "Complete Invite", 8 /* PROPS */, _hoisted_23)
    ])
  ]))
}